import type { RideAuthorization } from '@/lib/rides-types';
import { normalizeRideState } from '@/lib/ride-format';
import { OtpDisplay } from '@/components/ui/otp-display';

/**
 * Pickup OTP — the rider reads this out to the driver to start the trip (TRV10's
 * authorization is an OTP, not a QR). Emphasised once the driver has arrived.
 */
export function OtpCard({
  authorization,
  rideState,
}: {
  authorization: RideAuthorization;
  rideState?: string;
}) {
  const token = authorization.token;
  if (!token) return null;

  if (authorization.status === 'CLAIMED') {
    return (
      <div className="wb-card wb-card--pad wb-small">
        Pickup OTP verified — you&apos;re on your way.
      </div>
    );
  }

  const arrived = normalizeRideState(rideState) === 'RIDE_ARRIVED_PICKUP';
  return (
    <div
      className="wb-card wb-card--pad wb-col wb-center wb-gap-12"
      style={{
        textAlign: 'center',
        borderColor: arrived ? 'var(--honey)' : undefined,
        background: arrived ? 'var(--honey-wash-2)' : undefined,
      }}
    >
      <p className="wb-eyebrow">Pickup OTP</p>
      <OtpDisplay code={token} />
      <p className="wb-sub" style={{ maxWidth: 320 }}>
        {arrived
          ? 'Your driver has arrived. Read this OTP to them to start the ride.'
          : 'Read this OTP to your driver at pickup to begin the trip.'}
      </p>
    </div>
  );
}
